
/* injects from baggage-loader */

import { PlatesType } from '../types/plates';

import chefBook from '_images/locales/chef/book.png';
import chefDevice from '_images/locales/chef/device.png';

export const chef = {
    device: chefDevice,
    book: chefBook,
    type:1,
    description: 'Opções do Chef',
    tabs: [
        {
            title: "Entrada",
            items: [
                {
                    title: 'Dadinhos de tapioca',
                    price: 7.00,
                    desc: 'Pequenos pedaços de tapioca granulada com recheio de queijo coalho, temperados com sal e pimenta',
                    type: PlatesType.entrance
                },
                {
                    title: 'Bolinho de pirarucu',
                    price: 8.00,
                    desc: 'Bolinhos de batata recheados com peixe',
                    type: PlatesType.entrance
                },
                {
                    title: 'Caldo de peixe',
                    price: 8.00,
                    desc: 'Tigela de caldo de peixe temperado com alho, pimenta e azeite',
                    type: PlatesType.entrance
                },
                {
                    title: 'Caranguejo com farofa',
                    price: 9.00,
                    desc: 'Massa de caranguejo misturada com cebola, alho, pimentão e farofa',
                    type: PlatesType.entrance
                },
                {
                    title: 'Tapioca com queijo coalho',
                    price: 7.00,
                    desc: 'Farinha de mandioca preparada com água e sal, recheada com queijo',
                    type: PlatesType.entrance
                },
                {
                    title: 'Torresmo',
                    price: 7.00,
                    desc: 'Toucinho frito servido em pequenos pedaços',
                    type: PlatesType.entrance
                },
                {
                    title: 'Acarajé',
                    price: 9.00,
                    desc: 'Bolinho de massa de feijão, cebola e sal, frito em azeite de dendê e servido com vatapá e camarões',
                    type: PlatesType.entrance
                },
                {
                    title: 'Cuscuz de milho com leite',
                    price: 10.00,
                    desc: 'Massa de milho servida com leite',
                    type: PlatesType.entrance
                },
                {
                    title: 'Polenta',
                    price: 7.00,
                    desc: 'Pasta de fubá de milho com água e sal servida em manteiga ou queijo',
                    type: PlatesType.entrance
                },
                {
                    title: 'Pasta de batata',
                    price: 9.00,
                    desc: 'Massa de farinha de trigo com recheio de batata',
                    type: PlatesType.entrance
                },
                {
                    title: 'Pinhão Assado',
                    price: 5.00,
                    desc: 'Fruto de pinheiro assado na brasa',
                    type: PlatesType.entrance
                },
                {
                    title: 'Joelho de Porco',
                    price: 11.00,
                    desc: 'Joelho de porco acompanhando de batatas assadas',
                    type: PlatesType.entrance
                },
                {
                    title: 'Bolinho de aipim',
                    price: 9.00,
                    desc: 'Bolinhos fritos feitos com mandioca cozida e amassada, ovo, margarina, sal, recheados com queijo',
                    type: PlatesType.entrance
                },
                {
                    title: 'Feijão tropeiro',
                    price: 8.00,
                    desc: 'Feijão tropeiro com bacon, linguiça calabresa, ovos fritos picados, farinha de mandioca, temperado com azeite, cebola, alho, cheiro verde, sal e pimenta',
                    type: PlatesType.entrance
                },
                {
                    title: 'Tutu com torresmo',
                    price: 7.00,
                    desc: 'Feijão com torresmo pururuca, farinha de mandioca, água, ovos cozidos, temperado com alho, cebola, salsa e sal',
                    type: PlatesType.entrance
                },
                {
                    title: 'Pão de queijo',
                    price: 5.00,
                    desc: 'Polvilho azedo, água, leite, óleo, ovos, queijo parmesão ralado, sal',
                    type: PlatesType.entrance
                },
                {
                    title: 'Bolinho de arroz',
                    price: 12.00,
                    desc: 'Massa de arroz batida no liquidificador e frita com farinha de rosca',
                    type: PlatesType.entrance
                },
                {
                    title: 'Abobrinha recheada',
                    price: 10.00,
                    desc: 'Abobrinha recheada com carne moída, molho de tomate e queijo',
                    type: PlatesType.entrance
                },
                {
                    title: 'Polenta frita',
                    price: 9.00,
                    desc: 'Bolinho da massa de fubá frito e crocante',
                    type: PlatesType.entrance
                },
                {
                    title: 'Ventrecha de pacu frita',
                    price: 6.00,
                    desc: 'Postas de pacu frita',
                    type: PlatesType.entrance
                },
                {
                    title: 'Tutu com torresmo',
                    price: 8.00,
                    desc: 'Caldo de feijão engrossado na farinha de mandioca servido com toucinho frito em pequenos pedaços',
                    type: PlatesType.entrance
                }
            ],
        },
        {
            title: "Prato Principal",
            items: [
                {
                    title: 'Caldeirada de Tucunaré',
                    price: 40.00,
                    desc: 'Tucunaré em postas ao molho com ovos e batata',
                    type: PlatesType.principal
                },
                {
                    title: 'Pato no Tucupi',
                    price: 45.00,
                    desc: 'Carne de pato ao molho de goma e pimenta',
                    type: PlatesType.principal
                },
                {
                    title: 'Tilápia com molho de açaí',
                    price: 30.00,
                    desc: 'Tilápia servida com molho de açaí e purê de macaxeira',
                    type: PlatesType.principal
                },
                {
                    title: 'Peixada de Tambaqui',
                    price: 50.00,
                    desc: 'Peixe ao molho de creme de leite com pimentão, pimenta de cheiro e coentro',
                    type: PlatesType.principal
                },
                {
                    title: 'Maniçoba',
                    price: 35.00,
                    desc: 'Porção de folhas de mandioca, trituradas e acrescidas de carne suína e temperadas com alho, sal, louro e pimenta',
                    type: PlatesType.principal
                },
                {
                    title: 'Carne de sol com baião de dois',
                    price: 20.00,
                    desc: 'Carne bovina seca acompanhada de um preparado de arroz e feijão',
                    type: PlatesType.principal
                },
                {
                    title: ' Moqueca de peixe com pirão e arroz branco  ',
                    price: 25.00,
                    desc: 'Cozido de peixe e caldo misturado com farinha',
                    type: PlatesType.principal
                },
                {
                    title: 'Caruru',
                    price: 10.00,
                    desc: 'Cozido de quiabo servido com carne bovina, frango, peixe, azeite de dendê e pimenta',
                    type: PlatesType.principal
                },
                {
                    title: 'Paçoca',
                    price: 12.00,
                    desc: 'Farinha de mandioca e carne do sol socados juntos no pilão',
                    type: PlatesType.principal
                },
                {
                    title: 'Buchada de bode',
                    price: 30.00,
                    desc: 'Bucho com miúdos de bode temperado com cebola, pimentã, tomate, alho, sal e pimenta',
                    type: PlatesType.principal
                },
                {
                    title: 'Vatapá',
                    price: 15.00,
                    desc: 'Farinha de rosca, camarão, leite de coco, azeite de dendê',
                    type: PlatesType.principal
                },
                {
                    title: 'Barreado',
                    price: 20.00,
                    desc: 'Carne bovina, temperada com cebola, alho e toucinho de porco cozidos em uma panela de barro',
                    type: PlatesType.principal
                },
                {
                    title: 'Churrasco gáucho',
                    price: 25.00,
                    desc: 'Carnes diversas assadas na brasa',
                    type: PlatesType.principal
                },
                {
                    title: 'Arroz carreteiro',
                    price: 30.00,
                    desc: 'Cozido de quiabo servido com carne bovina, frango, peixe, azeite de dendê e pimenta',
                    type: PlatesType.principal
                },
                {
                    title: 'Ovelha no buraco',
                    price: 45.00,
                    desc: 'Ovelha assada com folhas de bandeira',
                    type: PlatesType.principal
                },
                {
                    title: 'Leitão Maturado',
                    price: 35.00,
                    desc: 'Porção de carne suína maturada, assada na brasa com sal e noz-moscada',
                    type: PlatesType.principal
                },
                {
                    title: 'Marreco recheado',
                    price: 40.00,
                    desc: 'Marreco ao forro recheado com miúdo e pães franceses, temperado com limão, cebola, salsinha e cebolinha',
                    type: PlatesType.principal
                },
                {
                    title: 'Feijoada',
                    price: 30.00,
                    desc: 'Feijão preto com carne seca, orelha, rabo, pé, costelinha e lombo de porco, linguiça portuguesa',
                    type: PlatesType.principal
                },
                {
                    title: 'Torta Capixaba',
                    price: 35.00,
                    desc: 'Torta feita com palmito, bacalhau, caranguejo, camarão, sururu, ovos, temperada com cebola, tomate, alho, coentro, sal e pimenta',
                    type: PlatesType.principal
                },
                {
                    title: 'Cuscuz à paulista',
                    price: 25.00,
                    desc: 'Farinha de milho com sardinha ou atum, ovos cozidos, ervilha, milho verde, cebola, pimentão, sal e pimenta',
                    type: PlatesType.principal
                },
                {
                    title: 'Frango com quiabo',
                    price: 20.00,
                    desc: 'Sobrecoxa ou coxa de frango com quiabo, cebola e tomates',
                    type: PlatesType.principal
                },
                {
                    title: ' Cupim casqueirado com batatas  ',
                    price: 45.00,
                    desc: 'Corte de carne cupim assado com manteiga, sal, azeite servido com batatas',
                    type: PlatesType.principal
                },
                {
                    title: 'Arroz com Pequi',
                    price: 25.00,
                    desc: 'Arroz cozido com pequi - fruta nativa do cerrado brasileiro',
                    type: PlatesType.principal
                },
                {
                    title: 'Galinha caipira',
                    price: 30.00,
                    desc: 'Galinha caipira cozida com legumes e verduras',
                    type: PlatesType.principal
                },
                {
                    title: 'Mojica de pintado',
                    price: 32.00,
                    desc: 'Peixe pintado cozido com farinha branca, temperada com cebola, tomate, pimenta, cheiro verde, pimenta e sal. Acompanha mandioca cozida cortada em pedaços',
                    type: PlatesType.principal
                },
                {
                    title: 'Empadão goiano',
                    price: 27.00,
                    desc: 'Torta salgada de lombo de porco e frango',
                    type: PlatesType.principal
                },
                {
                    title: 'Feijão frito',
                    price: 25.00,
                    desc: 'Feijão com farinha de mandioca refogado com cebolinha, pimenta do reino, sal e alho',
                    type: PlatesType.principal
                },
                {
                    title: 'Arroz com suã',
                    price: 30.00,
                    desc: 'Arroz refogado com lombo de porco',
                    type: PlatesType.principal
                },
                {
                    title: 'Olha ou Cozido',
                    price: 35.00,
                    desc: 'Costela de vaca cozida com mandioca, batata-doce e cenoura',
                    type: PlatesType.principal
                }
            ],
        },
        {
            title: "Sobremesa",
            items: [
                {
                    title: '  Bolo de castanha (pedaço)   ',
                    price: 5.00,
                    desc: 'Pedaço de bolo de castanha com recheio de ameixa',
                    type: PlatesType.dessert
                },
                {
                    title: 'Doce de cupuaçu',
                    price: 2.00,
                    desc: 'Preparado de cupuaçu com calda de açúcar',
                    type: PlatesType.dessert
                },
                {
                    title: 'Doce de buriti',
                    price: 2.00,
                    desc: 'Preparado de buriti com calda de açúcar',
                    type: PlatesType.dessert
                },
                {
                    title: 'Sorvete de tucumã',
                    price: 3.00,
                    desc: 'Bola de sorvete de tucumã',
                    type: PlatesType.dessert
                },
                {
                    title: 'Pudim de cupuaçu',
                    price: 4.00,
                    desc: 'Cupuaçu batido no liquidificador com leite condensado, creme de leite, ovos, açúcar e leite',
                    type: PlatesType.dessert
                },
                {
                    title: '  Bolo de rolo de goiaba (pedaço)   ',
                    price: 8.00,
                    desc: 'Massa de farinha de trigo, ovos, manteiga e açúcar enrolada com calda de goiaba',
                    type: PlatesType.dessert
                },
                {
                    title: 'Quebra-queixo  (pedaço)  ',
                    price: 5.00,
                    desc: 'Doce feito de coco com açúcar',
                    type: PlatesType.dessert
                },
                {
                    title: 'Pamonha doce',
                    price: 7.00,
                    desc: 'Milho verde triturado ao leite de coco e temperado com açúcar',
                    type: PlatesType.dessert
                },
                {
                    title: 'Cocada',
                    price: 5.00,
                    desc: 'Doce de coco ralado com calda de açúcar',
                    type: PlatesType.dessert
                },
                {
                    title: 'Doce de banana com creme leite',
                    price: 6.00,
                    desc: 'Banana em rodelas preparada em calda de açúcar',
                    type: PlatesType.dessert
                },
                {
                    title: 'Rapadura',
                    price: 5.00,
                    desc: 'Doce de açúcar mascavo com coco',
                    type: PlatesType.dessert
                },
                {
                    title: 'Mungunzá',
                    price: 8.00,
                    desc: 'Grãos de milho-branco cozidos em leite de coco e temperado com açúcar e canela em pó',
                    type: PlatesType.dessert
                },
                {
                    title: 'Banana frita com canela',
                    price: 2.00,
                    desc: 'Bananas fritas cortadas em tiras com canela',
                    type: PlatesType.dessert
                },
                {
                    title: 'Cuca',
                    price: 4.00,
                    desc: 'Bolo-pão de origem alemã com corbetura doce',
                    type: PlatesType.dessert
                },
                {
                    title: 'Chocolates caseiros',
                    price: 5.00,
                    desc: 'Chocolates diversos de produção própria',
                    type: PlatesType.dessert
                },
                {
                    title: 'Doce de maçã',
                    price: 7.00,
                    desc: 'Maçã em cubinhos, preparada ao suco de limão com açúcar e canela',
                    type: PlatesType.dessert
                },
                {
                    title: 'Pudim de Pinhão',
                    price: 8.00,
                    desc: 'Creme de leite condensado, essência de baunilha e massa de pinhão',
                    type: PlatesType.dessert
                },
                {
                    title: 'Bijaica',
                    price: 7.00,
                    desc: 'Biscoito feito de bouvilho azedo, ovos, açúcar e sal',
                    type: PlatesType.dessert
                },
                {
                    title: 'Sagu',
                    price: 9.00,
                    desc: 'Marreco ao forno recheado com miúdos e pães franceses, temperado com limão, cebola, salsinha e cebolinha',
                    type: PlatesType.dessert
                },
                {
                    title: 'Doce de ambrosia',
                    price: 4.00,
                    desc: 'Doce feito com leite, açúcar, ovos, pau de canela, cravos da índia e limão',
                    type: PlatesType.dessert
                },
                {
                    title: 'Brigadeiro',
                    price: 2.00,
                    desc: 'Leite condensado e cacau em pó',
                    type: PlatesType.dessert
                },
                {
                    title: 'Baba de moça',
                    price: 5.00,
                    desc: 'Leite condensado, leite de coco, gema e açúcar',
                    type: PlatesType.dessert
                },
                {
                    title: 'Pé-de-moleque',
                    price: 6.00,
                    desc: 'Amendoim sem casca, açúcar e leite condensado',
                    type: PlatesType.dessert
                },
                {
                    title: 'Paçoca de amendoim',
                    price: 3.00,
                    desc: 'Amendoim, farinha de mandioca e açúcar',
                    type: PlatesType.dessert
                },
                {
                    title: 'Cural',
                    price: 5.00,
                    desc: 'Milho verde, manteiga, açúcar e canela em pó',
                    type: PlatesType.dessert
                },
                {
                    title: 'Doce de leite',
                    price: 5.00,
                    desc: 'Doce a base de leite e açúcar',
                    type: PlatesType.dessert
                },
                {
                    title: 'Compotas de frutas',
                    price: 9.00,
                    desc: 'Cozimento de maçã e pera servido com uma calda de açúcar ',
                    type: PlatesType.dessert
                },
                {
                    title: 'Doce de mamão',
                    price: 7.00,
                    desc: 'Mamão pastoso em forma de purê',
                    type: PlatesType.dessert
                },
                {
                    title: ' Manjar branco com calda de ameixa  ',
                    price: 8.00,
                    desc: 'Massa gelada da mistura de leite, leite condensado, leite de coco, creme de leite e maizena',
                    type: PlatesType.dessert
                }
            ],
        },
        {
            title: "Bebidas",
            items: [
                {
                    title: 'Suco de Graviola',
                    price: 2.00,
                    type: PlatesType.drink
                },
                {
                    title: 'Suco de Buriti',
                    price: 2.00,
                    type: PlatesType.drink
                },
                {
                    title: 'Refrigerante de guaraná ',
                    price: 3.50,
                    type: PlatesType.drink
                },
                {
                    title: 'Cajuína',
                    price: 3.00,
                    type: PlatesType.drink
                },
                {
                    title: 'Caldo de cana',
                    price: 2.00,
                    type: PlatesType.drink
                },
                {
                    title: 'Suco de caju',
                    price: 3.00,
                    type: PlatesType.drink
                },
                {
                    title: 'Água de coco',
                    price: 5.00,
                    type: PlatesType.drink
                },
                {
                    title: 'Água',
                    price: 3.00,
                    type: PlatesType.drink
                },
                {
                    title: 'Suco de uva',
                    price: 5.00,
                    type: PlatesType.drink
                },
                {
                    title: 'Chimarrão',
                    price: 6.00,
                    type: PlatesType.drink
                },
                {
                    title: 'Tereré',
                    price: 7.00,
                    type: PlatesType.drink
                },
                {
                    title: 'Chá mate',
                    price: 5.00,
                    type: PlatesType.drink
                },
                {
                    title: 'Suco de limão',
                    price: 4.00,
                    type: PlatesType.drink
                },
                {
                    title: 'Capilé',
                    price: 6.00,
                    desc: 'Calda de suco de avenca - planta nativa do cerrado brasileiro',
                    type: PlatesType.drink
                },
                {
                    title: 'Jacuba',
                    price: 7.00,
                    desc: 'Farinha de mandioca,rapadura raspada e água gelada',
                    type: PlatesType.drink
                },
                {
                    title: 'Gengibirra',
                    price: 8.00,
                    desc: 'Água com abacaxi em pedaços e açúcar escuro a gosto',
                    type: PlatesType.drink
                }
            ],
        }
    ]
}

export default {
    chef
}



// WEBPACK FOOTER //
// ./src/app/components/ui/tab-book-reverso/tab-book-reverso.const.js